import React from 'react'
import PropTypes from 'prop-types'
import { StyleRadioButton } from './style'


const RadioButton = ({ data = [], options = [], language = 'EN', onSelected = () => {}, selectedKey = '', disabled = false, colorTheme }) => {
  const renderOption = () => {
    return options.map((item) => {
      const isSelected = selectedKey === item.key
      return (
        <div
          key={item.key}
          className={`radio-layout${disabled ? ' disabled' : ''}${isSelected ? ' active' : ''}`}
          onClick={() => disabled ? null : onSelected(item.key)}
        >
          <div className='custom-radio'>
            {isSelected && <div className='inner-circle' />}
          </div>
          <label className='radio-option'>{item[language]}</label>
        </div>
      )
    })
  }

  return (
    <StyleRadioButton colorTheme={colorTheme}>
      {renderOption()}
    </StyleRadioButton>
  )
}

RadioButton.propTypes = {
  data: PropTypes.array,
  options: PropTypes.array,
  language: PropTypes.string,
  onSelected: PropTypes.func,
  selectedKey: PropTypes.string,
  disabled: PropTypes.bool,
  colorTheme: PropTypes.string
}

export default RadioButton
